<template>
  <div>
    <router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import List from './running_orders/List'
import Editor from './running_orders/Editor'
import BottomSheet from '../BottomSheet'
export default {
  components: {
    BottomSheet
  },
  routes: [
    {
      path: '',
      redirect: '/settings/running_orders/list'
    },
    {
      path: "new",
      name: "New running order",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        edit: "Edit running order"
      }
    },
    {
      path: "edit/:id",
      name: "Edit running order",
      components: {
        default: List,
        bottomEditor: Editor
      },
      props: {
        default: false,
        bottomEditor: true
      }
    },
    {
      path: "list",
      name: "Running orders list",
      component: List
    }
  ],
}
</script>
